// This file is prefixed with @ to appear at the top when auto-sorting imports
import 'nprogress/nprogress.css'
import 'simplebar-react/dist/simplebar.min.css'
import './css/site.css'
import './initial'
import { setupProgress } from './utils/progress'

setupProgress()
